import React from 'react';
import { BaseCard } from '@bvt-shared/component/BaseCard';

import './AreaInfo.scss';
import { generateUUID } from '@bvt-utils';

/**
 * @type {React.FC<{
 * data:{
 * areaName:string
 * province:string
 * regency:string
 * district:string
 * village:string
 * areaTag:string[]
 * }
 * isLoading:boolean
 * }>}
 */
const AreaInfo = (props) => {
  const { data, isLoading, style } = props;
  return (
    <div className='feature-griana GrianaDashboardAreaInfoCard' style={style}>
      <BaseCard
        isLoading={isLoading}
        title='Area Info'
        withPadding={true}
      >
        <div className='GrianaDashboardAreaInfoCard__inner'>
          <div className='GrianaDashboardAreaInfoCard__top'>
            <div className='GrianaDashboardAreaInfoCard__title'>Area Name</div>
            <div className='GrianaDashboardAreaInfoCard__description'>
              {data?.areaName || '-'}
            </div>
          </div>
          <div className='GrianaDashboardAreaInfoCard__middle'>
            <div className='GrianaDashboardAreaInfoCard__title'>Province</div>
            <div className='GrianaDashboardAreaInfoCard__description'>
              {data?.province || '-'}
            </div>
          </div>
          <div className='GrianaDashboardAreaInfoCard__middle'>
            <div className='GrianaDashboardAreaInfoCard__title'>Regency</div>
            <div className='GrianaDashboardAreaInfoCard__description'>
              {data?.regency || '-'}
            </div>
          </div>
          <div className='GrianaDashboardAreaInfoCard__middle'>
            <div className='GrianaDashboardAreaInfoCard__title'>District</div>
            <div className='GrianaDashboardAreaInfoCard__description'>
              {data?.district || '-'}
            </div>
          </div>
          <div className='GrianaDashboardAreaInfoCard__middle'>
            <div className='GrianaDashboardAreaInfoCard__title'>Village</div>
            <div className='GrianaDashboardAreaInfoCard__description'>
              {data?.village || '-'}
            </div>
          </div>
          <div className='GrianaDashboardAreaInfoCard__middle'>
            <div className='GrianaDashboardAreaInfoCard__title'>Area Tag</div>
            <div className='GrianaDashboardAreaInfoCard__description'>
              {(data?.areaTag &&
                data.areaTag.map((v) => (
                  <div className='GrianaDashboardAreaInfoCard__description-tag' key={generateUUID()}>
                    {v}
                  </div>
                ))) ||
                '-'}
            </div>
          </div>
        </div>
      </BaseCard>
    </div>
  );
};
AreaInfo.displayName = 'GrianaDashboardAreaInfoCard';

export default AreaInfo;
